module.exports = __webpack_public_path__ + "static/media/green_panel.69c2bcf5.svg";